import { db, FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { queryShopSubscriptions } from 'reducks/shopSubscription/operations'
import { fetchShopSubscriptionsAction } from 'reducks/shopSubscription/actions'

const fetchShopSubscriptions = (shopRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    const storeRefs = await db
      .collection('stores')
      .where('shop_ref', '==', shopRef)
      .get()
      .then((snapshots) => {
        return snapshots.docs.map((snapshot) => {
          return snapshot.ref
        })
      })
    const ret = await Promise.all(storeRefs.map((storeRef) => queryShopSubscriptions(storeRef)))
    const shopSubscriptions = ret.flat()
    shopSubscriptions.sort((a, b) => {
      return a.is_sacri_station < b.is_sacri_station ? -1 : 1
    })
    dispatch(fetchShopSubscriptionsAction(shopSubscriptions, storeRefs))
  }
}

export default fetchShopSubscriptions
